// src/api/user.js
import request from './axiosRequest'

export const fetchBook = async () => {
    return await request.get('/api/v1/books')
}

export const fetchBookDetail = async (bookId) => {
    return await request.get(`/api/v1/books/${bookId}`)
}

export const fetchChapter = async (bookId, chapterId) => {
    return await request.get(`/api/v1/books/${bookId}/chapters/${chapterId}`)
}

// 获取章节关联的字符释义
export const fetchChapterChars = async (bookId, chapterId) => {
    return await request.get(`/api/v1/books/${bookId}/chapters/${chapterId}/chars`)
}

export const searchBooks = async (keyword) => {
    return await request.get('/api/v1/books/search', { params: { q: keyword } })
}

// ── 阅读进度 ──
export const fetchProgress = async (bookId) => {
    return await request.get(`/api/v1/progress/${bookId}`)
}

export const saveProgress = async (bookId, chapterId, scrollPct) => {
    return await request.post('/api/v1/progress', {
        book_id: bookId,
        chapter_id: chapterId,
        scroll_pct: scrollPct,
    })
}

// ── 书签 ──
export const fetchBookmarks = async (bookId) => {
    return await request.get('/api/v1/bookmarks', { params: { book_id: bookId } })
}

export const createBookmark = async (data) => {
    return await request.post('/api/v1/bookmarks', data)
}

export const deleteBookmark = async (id) => {
    return await request.delete(`/api/v1/bookmarks/${id}`)
}
